import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useQueryParams() {
  const { search } = useLocation();
  let queryString = search.replace('+', '%2B');

  return useMemo(() => new URLSearchParams(queryString), [queryString]);
}
